import { omit } from "@mixitone/util";
import { twMerge } from "tailwind-merge";
import { type Button, type ButtonKind, Spinner } from "./";
import { buttonClasses } from "../Styles/Buttons";

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  kind?: ButtonKind;
  spinner?: boolean;
  className?: string;
  groupPosition?: React.ComponentProps<typeof Button>["groupPosition"];
  ref?: React.Ref<HTMLAnchorElement>;
}

const Link: React.FC<LinkProps> = ({ ref, ...props }) => {
  const classes = buttonClasses({
    kind: props.kind || "primary",
    className: twMerge(props.className, ""),
  });

  return (
    <a {...omit(props, ["spinner", "groupPosition"])} onClick={props.onClick} className={classes} ref={ref}>
      <span className="inline-flex items-center gap-1">
        {props.spinner && <Spinner size={16} />}
        {!props.spinner && props.children}
      </span>
    </a>
  );
};

export { Link };
